import { ref, computed } from 'vue'

import axios from '@/plugins/axios'
import router from '@/router'

import { secondsToTime } from '@/utils'

const uuid = ref()
const needConfirm = ref()
const isEscort = ref()
const confirmPhone = ref()
const smsCode = ref()
const smsTimeRemaining = ref()
const smsTimeRemainingFormated = computed(() => secondsToTime(smsTimeRemaining.value, false))
const timer = ref()
let errors

function showConfirm(id, is_escort, errorsList) {
  uuid.value = id
  isEscort.value = is_escort
  errors = errorsList
  needConfirm.value = true
  startTimer()
}
function startTimer() {
  smsTimeRemaining.value = 60
  clearInterval(timer.value)
  timer.value = setInterval(smsTimer, 1000)
}
function smsTimer() {
  smsTimeRemaining.value--

  if (smsTimeRemaining.value == 0) {
    clearInterval(timer.value)
  }
}

async function sendNewSms() {
  delete errors.value.sms_code

  try {
    await axios.post('send-new', { uuid: uuid.value })
    startTimer()
  } catch (_error) {}
}

async function clickConfirm() {
  delete errors.value.sms_code

  try {
    await axios.post('confirmation', { uuid: uuid.value, sms_code: smsCode.value })
    router.push('/registered')
  } catch ({ response }) {
    errors.value.sms_code =
      response && response.data && response.data.errors ? response.data.errors.sms_code : undefined
  }
}

export {
  needConfirm,
  isEscort,
  confirmPhone,
  smsCode,
  smsTimeRemaining,
  smsTimeRemainingFormated,
  showConfirm,
  sendNewSms,
  clickConfirm,
}
